import React, { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";

import { FileResponse } from "../../types/FileResponse";
import { BeatLoader } from "react-spinners";
import { Box, Button, MenuItem, Select, Stack } from "@mui/material";
import { getArtistPhoto } from "../../components/apis/music-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import callApi from "../../components/call-api/call-api";
import { PhotoRating } from "../../types/PhotoRating";

type PhotoRowProps = {
    letter: string,
    artistName: string,
    photoName: string,
    deletePhoto: (name: string) => void;
    isProcessing: boolean;
    onRatingChange: (photoName: string, rating: PhotoRating) => void;
}

const PhotoRow = (props: PhotoRowProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ photo, setPhoto ] = useState<FileResponse>();
    const [ rating, setRating ] = useState<PhotoRating>(PhotoRating.General);

    useEffect(() => {
        callApi<FileResponse>(getArtistPhoto(getAccessToken(), props.artistName, props.photoName), setPhoto);
    }, [props.artistName, props.photoName, getAccessToken]);

    useEffect(() => {
        const initialRating = props.photoName.endsWith('_G.jpg')
            ? PhotoRating.General : props.photoName.endsWith('_R.jpg')
            ? PhotoRating.Restricted : props.photoName.endsWith('_X.jpg')
            ? PhotoRating.Explicit : PhotoRating.General;
        setRating(initialRating);
    }, [props.photoName]);

    return (
        <Stack direction="row" spacing={3}>
            <Box sx={{ width: '280px' }}>
                <img alt={props.photoName} width={'280 px'} src={`data:image/jpeg;base64,${photo?.fileContents}`} />
                <BeatLoader
                    loading={photo?.fileContents === undefined}
                    size={24}
                    aria-label="Loading Spinner"
                    data-testid="loader" />
            </Box>
            <Box>
                <Select
                    size="small"
                    value={rating}
                    onChange={(e) => props.onRatingChange(props.photoName, e.target.value as PhotoRating)}
                    disabled={props.isProcessing}
                    sx={{ minWidth: '80px' }}
                >
                    <MenuItem value={PhotoRating.General}>G</MenuItem>
                    <MenuItem value={PhotoRating.Restricted}>R</MenuItem>
                    <MenuItem value={PhotoRating.Explicit}>X</MenuItem>
                </Select>
            </Box> 
            <Box>
                <Button
                    variant="contained"
                    disabled={props.isProcessing}
                    onClick={() => props.deletePhoto(props.photoName)}
                >
                    <FontAwesomeIcon fontSize="large" color="primary" icon={faTrashCan} className="icon"/>
                    Delete
                </Button>
            </Box>
            <Box>
                {props.photoName}
            </Box>
        </Stack>
    );
}

export default PhotoRow;